import React, {useContext, useEffect, useState} from "react";
import Styles from './AssignWorkSpace/AssignWorkSpace.module.scss'
import appContext from "../../../../context/appContext";
import http from "../../../../services/api/utilities/http";

const AssignWorkSpace = ({ datapoolId, cacheStatus = "ready", oneCacheInProgress }) => {
  const context = useContext(appContext)
  const [open,setOpen] = useState(false)
  const [status, setStatus] = useState(null)

  useEffect(() => {
    if (!cacheStatus) return
    setStatus(cacheStatus)
  }, [cacheStatus])

  const handleCreateCache = (e) => {
    e.stopPropagation()
    http.post('process_mining/process_explorer_preload/',
      {
        data_pool_id: datapoolId
      })
      .then(res => {
        setStatus("in_progress")
      })
      .catch(err => {
        setStatus("ready")
        console.log(err.response)
      })
  }

  return(
    <div className={Styles.container} tabIndex={-1} onBlur={()=>setOpen(false)}>
      <p onClick={handleCreateCache} style={{marginTop: 16, fontStyle: status === "done" || status === "in_progress" || oneCacheInProgress ? 'italic' : 'normal'}} className={`fw600 f12 main-purple ${(status === "done" || status === "in_progress" || oneCacheInProgress) && 'disable'}`}>{(status === "done" || status === "in_progress") ? status === "done" ? "Process Explorer Cached!" : "Caching in progress..." : "Create Process Explorer Cache"}</p>
      <p onClick={() => setOpen(!open)} style={{marginTop: 8}} className={`fw600 disable f12 main-purple ${context.handleWorkspace() == 0 && 'opacity-0'}`}>Assign To A Work Space</p>
        {open &&
          <div className={Styles.selectBox}>
            {context.handleWorkspace().map((w,key)=>(
                <p key={key} className="f12 fw500">{w.name}</p>
            ))}
          </div>
        }
    </div>
  )
}
export default AssignWorkSpace;
